<template>
    <v-container class="fill-height" style="display: block;" fluid>

    <template v-if="$store.state.batchConfig.webapp_reports">

       <v-stepper class="stepper" style="background: #424242;" v-model="currentStep">
            <v-stepper-header style="height: 50px;">
                <v-stepper-step class="stepper-step" step="1" :complete="currentStep > 1" editable :color="'#c42111'">Select Report</v-stepper-step>
                <v-divider style="margin: 0px -6px;"></v-divider>
                <v-stepper-step class="stepper-step" step="2" :complete="currentStep > 2" editable :color="'#c42111'">Edit Parameters</v-stepper-step>
                <v-divider style="margin: 0px -6px;"></v-divider>
                <v-stepper-step class="stepper-step" step="3" :complete="currentStep > 3" editable :color="'#c42111'">Report Results</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items class="stepper-content-container">
                <v-stepper-content :step="1" class="stepper-content">
                    <reports-list :reports="reports" :reportFilters="reportFilters" :licensableReports="licensableReports" @reportClicked="getReportInfo" @filters="updateFilters" @reload="getReportList" @licensableReportClick="licensableReportClick" @deleteLicensableReportClick="deleteLicensableReportClick" v-if="reportFilters"></reports-list>
                </v-stepper-content>
                <v-stepper-content :step="2" class="stepper-content">
                    <report-params :reportTitle="selectedReport.user_obj_name" :reportDetails="selectedReportDetails" :actionButtonText="'Run Report'" :collectMode="false" :reportFilters="reportFilters" :runIncognito="runIncognito" @action="runReport" @background="runReportInBackground" @email="runReportEmailResults" @runIncognito="setRunIncognito" @notes="showReportNotes = true" v-if="selectedReportDetails"></report-params>
                    <span class="placeholder-text" v-if="!selectedReportDetails">Please select a report first</span>
                </v-stepper-content>
                <v-stepper-content :step="3" class="stepper-content less-pad">
                    <report-results :selectedReport="selectedReport" :reportDetails="selectedReportDetails" :reportData="reportData" :runReportParams="runReportParams" :runReportHumanText="runReportHumanText" @forceRefresh="forceRefresh" @autoRefreshFile="autoRefreshFile" @notes="showReportNotes = true" v-if="reportData"></report-results>
                    <span class="placeholder-text" v-if="!reportData && !reportFile">Please run a report first</span>
                    <div class="report-download-container" v-if="reportFile">
                        <span>Report results are too large. Downloading results in a <i>csv</i> file.</span>
                        <div v-if="!selectedReport.history && reportFileCached">
                            <span>(results were cached)
                            <v-btn class="mx-1 ml-1 grid-button" fab dark x-small color="#c42111" @click="forceRefresh">
                                <v-icon dark>mdi-table-refresh</v-icon>
                            </v-btn></span>
                        </div>
                        <v-btn class="download" @click="downloadReportFile">
                            <span v-text="reportFilePrettyName"></span>
                        </v-btn>
                    </div>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

    </template>

    <v-dialog v-model="showReportResultsPrompt" max-width="80%" width="550px" persistent v-if="showReportResultsPrompt">
        <report-results-prompt :runResult="runReportResults" @handle="handleReportResultsPromptResponse"></report-results-prompt>
    </v-dialog>

    <v-dialog v-model="showReportNotes" max-width="80%" width="1600px" persistent v-if="showReportNotes" @keydown="(k) => {k.key == 'Escape' ? showReportNotes = false : null}">
        <report-notes :notes="selectedReportDetails.notes" @close="showReportNotes = false" v-if="showReportNotes"></report-notes>
    </v-dialog>


    <template v-if="!$store.state.batchConfig.webapp_reports">
        <div class="no-license-text">
            <p>
                You do not have a license for Telsasoft Reports. <br>
                Please visit <a style="color:#c42111;" href="https://telsasoft.com/opsalert/" target="_blank">here</a> for more information.
            </p>
        </div>
    </template>

  </v-container>
</template>

<script>
import ReportsList from '@/components/Reports/ReportsList';
import ReportParams from '@/components/Reports/ReportParams';
import ReportResults from '@/components/Reports/ReportResults';
import ReportResultsPrompt from '@/components/Reports/ReportResultsPrompt';
import ReportNotes from '@/components/Reports/ReportNotes';
export default {
    name: 'Reports',
    components: {
        ReportsList,
        ReportParams,
        ReportResults,
        ReportResultsPrompt,
        ReportNotes
    },
    data: () => ({
        reports: [],
        selectedReport: null,
        selectedReportDetails: null,
        reportData: null,
        reportFile: null,
        reportFilePrettyName: null,
        reportFileCached: null,
        currentStep: 1,
        runReportParams: '',
        runReportHumanText: '',
        reportFilters: null,
        showReportResultsPrompt: false,
        runReportResults: null,
        runIncognito: false,
        licensableReports: null,
        showReportNotes: false
    }),

    computed: {
        isTsAdmin: function() {
            if(this.$store.state.user.user_data && this.$store.state.user.user_data.is_telsasoft_admin) {
                return true;
            }
            return false;
        }
    },

    methods: {
        getReportList: function() {
            this.selectedReportDetails = null;
            let route = (TELSA.apiHost + "report/list");
            TELSA.loading(true);
            return this.$http.get(route, {args: {}}).then(response => {
                let result = response.body;
                this.reports = result.report_list;
                this.reportFilters = result.report_filters;
                for(let report of this.reports) {
                    report.hasPermissions = TELSA.checkPermissionQualifier(this.$store.state.user, `reports/run`, report.user_obj_name, !this.$store.state.batchConfig.product_perms);
                }
                TELSA.loading(false);
            });
        },

        getReportInfo: function(report) {
            if(!report.hasPermissions) {
                this.$store.commit('insufficientPermissions', {message: `You do not have permission to run this report.`});
                return;
            }
            this.selectedReport = report;
            this.reportData = null;
            this.reportFile = null;
            this.selectedReportDetails = null;
            let route = (TELSA.apiHost + "report/info");
            TELSA.loading(true);
            return this.$http.post(route, {args: {report: report.user_obj_name}}).then(response => {
                let result = response.body;
                this.selectedReportDetails = result.data;
                if(result.data.rpt_params.length) {
                    this.currentStep = 2;
                }
                else {
                    this.runReport().then(() => {
                        this.currentStep = 3;
                    });
                }
                TELSA.loading(false);
            });
        },

        runReport: function(params, humanTextArr, noCache=false) {
            this.reportFilters.report_run_method = 'run';
            this.updateFilters();
            this.runReportParams = params;
            this.runReportHumanText = humanTextArr;
            let route = (TELSA.apiHost + "report/run");
            this.reportData = null;
            this.reportFile = null;
            this.reportFileCached = null;
            TELSA.loading(true);
            let startTimestamp = Date.now();
            this.$store.commit('setAiAnalyzerGridAPI', null);
            return this.$http.post(route, {args: {report: this.selectedReport.user_obj_name, params: params, humanParams: humanTextArr, noCache: noCache, runIncognito: !!this.runIncognito}}).then(response => {
                let result = response.body;
                console.log('RESULT', result);
                if(result == 'no_report') {
                    this.$store.commit('showConfirmModal', {
                        type: 'error',
                        hideCancel: true,
                        title: 'Report Error',
                        message: 'Report not found.',
                        confirmAction: () => {this.$store.commit('closeConfirmModal');}
                    });
                    TELSA.loading(false);
                    return;
                }

                TELSA.loading(false);
                if(result.file_name) {
                    this.reportFile = result.file_name;
                    this.reportFilePrettyName = result.pretty_file_name;
                    this.reportFileCached = result.cached;
                    this.downloadReportFile();
                    this.currentStep = 3;
                }
                // else if(result.file_name) {
                //     result.runTime = (Date.now() - startTimestamp);
                //     this.runReportResults = result;
                //     this.showReportResultsPrompt = true;
                // }
                else {
                    this.reportData = result.data;
                    this.reportData.runTime = (Date.now() - startTimestamp);
                    this.currentStep = 3;
                }
            });
        },

        handleReportResultsPromptResponse: function(response, result) {
            this.showReportResultsPrompt = false;
            if(response == 'app') {
                // Go get report data
                let route = (TELSA.apiHost + "report/history/result");
                TELSA.loading(true);
                return this.$http.post(route, {args: {report_name: this.selectedReport.user_obj_name, params_hash: result.params_hash, force_web: true}}).then(response => {
                    this.reportData = response.data;
                    this.reportData.runTime = result.runTime;
                    this.currentStep = 3;
                    TELSA.loading(false);
                });
            }
            else {
                this.reportFile = result.file_name;
                this.reportFilePrettyName = result.pretty_file_name;
                this.reportFileCached = result.cached;
                this.downloadReportFile();
                this.currentStep = 3;
            }
        },

        runReportInBackground: function(params, humanTextArr, noCache=false) {
            this.reportFilters.report_run_method = 'background';
            this.updateFilters();
            this.$store.dispatch('runReportInBackground', {report: this.selectedReport.user_obj_name, params: params, humanParams: humanTextArr, noCache: noCache, email: false});
        },

        runReportEmailResults: function(params, humanTextArr, noCache=false) {
            this.reportFilters.report_run_method = 'email';
            this.updateFilters();
            this.$store.dispatch('runReportInBackground', {report: this.selectedReport.user_obj_name, params: params, humanParams: humanTextArr, noCache: noCache, email: this.$store.state.user.user_page_email});
        },

        downloadReportFile: function() {
            let dlink = document.createElement('a');
            dlink.setAttribute("id", "report-download-file-link-hidden");
            let url = new URL(`${TELSA.staticHost}${this.reportFile}?prettyname=${this.reportFilePrettyName}`);
            dlink.href = url;
            dlink.click();
            dlink.remove();
        },

        updateFilters: function() {
            let favs = this.reports.filter(report => {
                return report.fav;
            }).map(x => {
                return { user_obj_name: x.user_obj_name };
            });
            let route = (TELSA.apiHost + "report/filters");
            this.$http.post(route, {args: {favs: favs, reportFilters: this.reportFilters}}).then(response => {
                let result = response.body;
            }, error => {
                alert('could not save report favorites');
            });
        },

        forceRefresh: function() {
            // Rerun this report with the same params but tell the server to not return the cache result.
            this.runReport(this.runReportParams, this.runReportHumanText, true);
        },

        autoRefreshFile: function(result) {
            // Report auto refresh results returned a file. We want to stop the auto refreshing and download the file. 
            this.reportData = null;
            this.reportFile = result.file_name;
            this.reportFilePrettyName = result.pretty_file_name;
            this.reportFileCached = result.cached;
            this.downloadReportFile();
        },

        setRunIncognito: function(value) {
            this.runIncognito = value;
        },

        getLicensableReports: function() {
            let route = (TELSA.apiHost + "report/licensablelist");
            this.$http.get(route).then(response => {
                let result = response.body;
                this.licensableReports = result;
                console.log("getLicensableReports: ", result);
            });
        },

        licensableReportClick: function(report) {
            console.log('licensableReportClick: ', report);
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: `Are you sure you want to license the <b>${report.lr_name}</b> report?`,
                type: 'confirm',
                confirmAction: () => {this.licensableReport(report);}
            });
        },
        licensableReport: function(report) {
            let route = (TELSA.apiHost + "report/licensableadd");
            this.$http.post(route, {args: {report: report.lr_name}}).then(response => {
                let result = response.body;
                this.licensableReports.splice(this.licensableReports.indexOf(report), 1);
                console.log('REPORT LICENSED NOW')
            });
        },

        deleteLicensableReportClick: function(report) {
            console.log('delete licensableReport: ', report);
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: `Are you sure you want to remove the <b>${report.user_obj_name}</b> report?`,
                type: 'warning',
                confirmAction: () => {this.deleteLicensableReport(report);}
            });
        },
        deleteLicensableReport: function(report) {
            let route = (TELSA.apiHost + "report/licensabledelete");
            this.$http.post(route, {args: {report: report.user_obj_name}}).then(response => {
                let result = response.body;
                this.licensableReports = result;
                this.reports.splice(this.reports.indexOf(report), 1);
                console.log('LICENSED REPORT DELETED')
            });
        }
    },

    watch: {
    },

    mounted() {
        // If they don't have a license for reports then dont start anything.
        if(!this.$store.state.batchConfig.webapp_reports) {
            return;
        }
        this.getReportList();
        if(this.isTsAdmin) {
            this.getLicensableReports();
        }
    }

  
};
</script>

<style scoped>

    .placeholder-text {
        color: rgba(255, 255, 255, 0.5);
        display: block;
        font-size: 18pt;
        text-align: center;
        margin-top: 30vh;
    }

    .stepper {
        background: #424242; 
        height: calc(100vh - 80px);
        width: 100%;
    }
    .stepper .stepper-step {
        padding: 12px 24px;
    }
    .stepper-content-container {
        overflow-y: auto; 
        height: calc(100% - 55px);
    }
    .stepper-content {
        
    }
    .stepper-content.less-pad {
        padding: 16px 4px 4px 4px;
    }

    .report-download-container {
        text-align: center;
        font-size: 16pt;
        margin-top: 3em;
    }
    .report-download-container .download {
        display: block;
        margin: auto;
        margin-top: 1em;
    }
    
</style>
